// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"CampaignList_blockClick_1Czj_"};